'use client';

/**
 * DividerField — Visual section divider / horizontal rule.
 *
 * Config via field.metadata:
 *   style: 'solid' | 'dashed' | 'dotted' | 'double' (default 'solid')
 *   color: string (CSS colour)
 *   spacing: 'sm' | 'md' | 'lg' (default 'md')
 *   label: string (optional centre label)
 */

import React from 'react';
import type { FieldComponentField } from '../formFieldTypes';

interface DividerFieldProps {
  field: FieldComponentField;
  isDark: boolean;
}

export const DividerField: React.FC<DividerFieldProps> = ({ field, isDark }) => {
  const meta = field.metadata as {
    style?: 'solid' | 'dashed' | 'dotted' | 'double';
    color?: string;
    spacing?: 'sm' | 'md' | 'lg';
    label?: string;
  } | undefined;
  const style = meta?.style || 'solid';
  const color = meta?.color || (isDark ? '#374151' : '#e5e7eb');
  const spacing = meta?.spacing || 'md';
  const label = meta?.label || '';

  const py = spacing === 'sm' ? 'py-2' : spacing === 'lg' ? 'py-6' : 'py-4';

  if (label) {
    return (
      <div className={`${py} col-span-full`}>
        <div className="relative flex items-center">
          <div className="flex-grow border-t" style={{ borderStyle: style, borderColor: color }} />
          <span className={`px-3 text-xs font-medium ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
            {label}
          </span>
          <div className="flex-grow border-t" style={{ borderStyle: style, borderColor: color }} />
        </div>
      </div>
    );
  }

  return (
    <div className={`${py} col-span-full`}>
      <hr style={{ borderStyle: style, borderColor: color, borderWidth: '1px 0 0 0' }} />
    </div>
  );
};
